var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.3 4.8h-1.8v-.9a.9.9 0 1 0-1.8 0v.9H9.3v-.9a.9.9 0 0 0-1.8 0v.9H5.7A2.7 2.7 0 0 0 3 7.5v10.8A2.7 2.7 0 0 0 5.7 21h12.6a2.7 2.7 0 0 0 2.7-2.7V7.5a2.7 2.7 0 0 0-2.7-2.7m.9 13.5a.9.9 0 0 1-.9.9H5.7a.9.9 0 0 1-.9-.9V12h14.4zm0-8.1H4.8V7.5a.9.9 0 0 1 .9-.9h1.8v.9a.9.9 0 0 0 1.8 0v-.9h5.4v.9a.9.9 0 1 0 1.8 0v-.9h1.8a.9.9 0 0 1 .9.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/calendar.002e0f2b9f240510a07139d8d73366f3.svg";